import React, { useState, useRef } from 'react';
import '../scss/MultiKeySearchBar.scss';

const MultiKeySearchBar = ({
    onKeysChange,
    placeholder = 'Search MDRM, Schedule, Item Name...',
}) => {
    const [inputValue, setInputValue] = useState('');
    const [keys, setKeys] = useState([]);
    const [isFocused, setIsFocused] = useState(false);
    const inputRef = useRef(null);

    const MAX_TAGS = 3;

    let inputWidth;

    if (keys.length === 1) {
        inputWidth = 275;
    } else if (keys.length === 2) {
        inputWidth = 210;
    } else if (keys.length === MAX_TAGS) {
        inputWidth = 0;
    } else {
        inputWidth = `100%`;
    }

    const containerWidth = '100%';

    const addKey = (key) => {
        const trimmed = key.trim();
        if (trimmed && !keys.includes(trimmed)) {
            if (keys.length >= MAX_TAGS) {
                return;
            }
            const newKeys = [...keys, trimmed];
            setKeys(newKeys);

            if (onKeysChange) {
                onKeysChange(newKeys);
            }

            if (newKeys.length === MAX_TAGS && inputRef.current) {
                inputRef.current.blur();
            }
        }
    };

    const removeKey = (keyToRemove) => {
        const filtered = keys.filter((k) => k !== keyToRemove);
        setKeys(filtered);
        onKeysChange && onKeysChange(filtered);

        if (inputRef.current) {
            inputRef.current.focus();
        }
    };

    const handleInputChange = (e) => {
        if (keys.length < MAX_TAGS) {
            setInputValue(e.target.value);
        }
    };

    const handleKeyDown = (e) => {
        if (['Enter', ' ', ','].includes(e.key)) {
            e.preventDefault();
            if (keys.length < MAX_TAGS) {
                addKey(inputValue);
                setInputValue('');
            }
        } else if (e.key === 'Backspace' && inputValue === '' && keys.length) {
            removeKey(keys[keys.length - 1]);
        }
    };

    return (
        <div
            className="multi-key-search-container justify-start"
            style={{
                width: containerWidth,
                maxWidth: '100%',
                border: isFocused ? '1px solid #e0301e' : '1px solid #ccc',
                transition: 'border-color 0.3s ease',
            }}
            tabIndex={0}
            onClick={() => inputRef.current?.focus()}
        >
            <div className="multi-key-search-tags">
                {keys.map((key) => (
                    <div className="multi-key-tag" key={key}>
                        <div className="multi-key-tag-text" title={key}>
                            {key}
                        </div>
                        <button
                            type="button"
                            className="multi-key-tag-remove"
                            aria-label={`Remove ${key}`}
                            onClick={(e) => {
                                e.stopPropagation();
                                removeKey(key);
                            }}
                        >
                            ×
                        </button>
                    </div>
                ))}
            </div>
            {keys.length < MAX_TAGS && (
                <input
                    style={{ width: inputWidth }}
                    ref={inputRef}
                    type="text"
                    placeholder={
                        keys.length > 0 && inputValue.length === 0 ? '' : placeholder
                    }
                    value={inputValue}
                    onChange={handleInputChange}
                    onKeyDown={handleKeyDown}
                    onFocus={() => setIsFocused(true)}
                    onBlur={() => setIsFocused(false)}
                    className={`multi-key-search-input${keys.length >= MAX_TAGS ? ' disabled' : ''}`}
                    disabled={keys.length >= MAX_TAGS}
                />
            )}
        </div>
    );
};

export default MultiKeySearchBar;
